<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-10">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">Отмена ошибочной оплаты</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Ресепшен / Рабочий стол / Возврат /</span> Отмена ошибочной оплаты</div>
                </div>
              </v-col>
              <v-col>
                <v-sheet class="card rounded-lg" style="padding: 0 !important;">
                  <div class="column" style="padding-top: 20px !important;">
                    <VueDatePicker
                        no-title
                        no-header
                        range
                        :rangeInputText="date.start === date.end ? '%d' : '%d - %d'"
                        format="DD MMMM"
                        color="#629f34"
                        v-model="date"
                        style="flex: none !important;"
                    >
                      <template #activator="{ date }">
                        <button
                            class="button custom__button"
                            ref="activator"
                            type="button"
                        >
                          <v-icon
                              dark
                              right
                              small
                              class="mr-2"
                          >
                            mdi-calendar-blank-outline
                          </v-icon>
                          {{ date }}
                        </button>
                      </template>
                    </VueDatePicker>
                  </div>
                  <div class="column mt-5">
                    {{ client.name }}
                  </div>
                  <v-data-table
                      :headers="headersPayment"
                      :items="payments ? payments.payments : []"
                      item-key="pay_id"
                      no-data-text="Ничего не найдено"
                      v-model="selectPayment"
                      hide-default-footer
                      show-select
                      class="elevation-1 mt-5 custom__table"
                  >
                    <template v-slot:header.data-table-select="{ on, props }">
                      <v-tooltip
                          top
                          content-class="black tooltip-top"
                      >
                        Выбрать все
                        <template v-slot:activator="{ on: onTooltip }">
                          <v-simple-checkbox
                              v-ripple
                              color="#629F33"
                              v-bind="props"
                              v-on="{ ...on, ...onTooltip }"
                          ></v-simple-checkbox>
                        </template>
                      </v-tooltip>
                    </template>
                    <template v-slot:item.data-table-select="{ isSelected, select }">
                      <v-simple-checkbox style="width: 26px !important;" color="#629F33" :value="isSelected" @input="select($event)"></v-simple-checkbox>
                    </template>
                  </v-data-table>
                  <div class="column mt-5" style="padding-bottom: 20px !important;">
                    <template v-if="selectPayment.length > 0">
                      <v-btn
                          dark
                          class="apply-button"
                          style="background-color: #A13453 !important; color: #FFFFFF!important;"
                          @click="dialogModal = true"
                      >
                        Применить
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-btn
                          dark
                          class="apply-button"
                      >
                        Применить
                      </v-btn>
                    </template>
                  </div>
                </v-sheet>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-row justify="center">
          <v-dialog
              v-model="dialogModal"
              persistent
              max-width="400px"
          >
            <v-card>
              <v-card-title class="text-center">
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogModal = false" >
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text style="padding-bottom: 30px;">
                <v-container>
                  <div>
                    <h3 class="card-title">Вы уверены, что хотите отменить оплату?</h3>
                  </div>
                  <v-row
                      class="mt-5 justify-center"
                  >
                    <button
                        class="button button__danger"
                        ref="activator"
                        type="button"
                        @click="makeCancel"
                    >
                      Да
                    </button>
                    <button
                        class="button button__unlock ml-5"
                        ref="activator"
                        type="button"
                        @click="dialogModal = false"
                    >
                      Нет
                    </button>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {VueDatePicker} from "@mathieustan/vue-datepicker";
import {returnActionTypes} from '@/store/modules/return';
import {cashboxActionTypes} from '@/store/modules/cashbox';
import {mapState} from "vuex";
import {getItem, setItem} from "../helpers/persistanceStorage";

export default {
  name: "ReturnCancelPayment",
  props: ['client','buy','datebuy'],
  components: {
    Header,
    Menu,
    VueDatePicker
  },
  computed: {
    ...mapState({
      isLoading: state => state.refund.isLoading,
      payments: state => state.refund.payments,
      validationErrors: state => state.refund.validationErrors,
    })
  },
  data() {
    return {
      date: new Date(),
      selectPayment: [],
      dialogModal: false,
      headersPayment: [
        {text: 'Дата', align: 'start', sortable: false, value: 'date', width: '10%'},
        {text: 'Оплата', align: 'start', value: 'pay_name', width: '35%'},
        {text: 'Сумма для возврата', align: 'start', value: 'sum', width: '20%'},
        {text: 'Допустимое действие', align: 'start', value: 'available_action', width: '35%'},
      ],
      listCashbox: JSON.parse(getItem('list-cashbox')) ?? null,
      cashboxTerminal:"f0eb54ae-0b16-11ec-a060-60e32700ce56"
    }
  },
  methods: {
    setCashboxTerminal(){
      if(!this.listCashbox || !this.listCashbox[0]){
        alert('Не подключена или неполадки с кассой! Автоматически подставлена касса ИП Сорокин на Reception3_kl!')
      } 
      this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
        till_id: (this.listCashbox && this.listCashbox[0] && this.listCashbox[0].serial) ? this.listCashbox[0].serial : "00108723658089"
      }).then((resp) => {
       console.log(resp)
       if(resp && resp.cashbox && resp.cashbox.terminals && resp.cashbox.terminals.length > 0) {
          this.cashboxTerminal = resp.cashbox.terminals[0].id
       } 
      //  else {
      //    alert('Неполадки с кассой, либо нет терминалов по выбранной кассе! Автоматически подставился стандартный теримнал ООО Клевер!')
      //  }
      })
    },
    fetchFeed(client_id, date) {
      this.$store.dispatch(returnActionTypes.getReturnPayments, {
        client_id,
        startdate: date,
        enddate: date
      }).then((response) => {

        if(this.payments) {
          console.log(this.payments)
          if(this.buy && this.buy.pays && this.buy.pays.length > 0){
            for(let i = 0; i < this.payments.payments.length; i++){
              for(let j = 0; j < this.buy.pays.length; j++){
                if(this.payments.payments[i].pay_id === this.buy.pays[j].id){
                  //this.newList.push(this.products.products[i])
                  this.selectPayment.push(this.payments.payments[i])
                } 
              }
            }
          }


        }
      })
    },
    makeCancel() {
      let list = [];
      for (let item of this.selectPayment) {
        list.push({
          service_id: item.pay_id,
          service_name: item.pay_name,
          count: item.count,
          sum: item.sum,
        })
        this.$store.dispatch(returnActionTypes.returnReceipt, {
          till_id: this.listCashbox[0].serial,
          auth_code: item.pay_type === 3 ? this.buy.pay_list[0].transaction_id : null,
          type: item.pay_type,
          return_list: list
        })
          .then((response) => {
            if (response.success) {
              this.$store.dispatch(returnActionTypes.makeCancel, {
                client_id: this.client.client_id,
                pay_id: item.pay_id,
                till_id: item.till_id,
                type: item.pay_type,
                summ: item.sum,
                check_number: response.receipt_number,
                terminal_id: item.pay_type === 3 ? this.cashboxTerminal : null,
                transaction_id: item.pay_type === 3 ? response.auth_code : null,
                transaction_date: item.pay_type === 3 ? new Date() : null
              })
            }
          })
      }
      this.dialogModal = false;
      this.fetchFeed(this.client.client_id, this.date);
    }
  },
  mounted() {
    this.client !== undefined ? setItem('return-client',JSON.stringify(this.client)) : this.client = this.client = JSON.parse(getItem('return-client'));

    console.log(this.datebuy)
    console.log(this.buy)
    console.log(this.client)
    if(this.client && this.client.first_name) {
      this.client.name = this.client.last_name + ' ' + this.client.first_name
      this.client.id = this.client.client_id
    }

    let datFind = this.date

    if(this.datebuy){
      datFind = this.datebuy
    }

    this.fetchFeed(this.client.client_id, datFind);
    this.setCashboxTerminal()
  },
  watch: {
    date() {
      this.$store.dispatch(returnActionTypes.getReturnPayments, {
        client_id: this.client.client_id,
        date: this.date.start === this.date.end ? this.date.start : null,
        startdate: this.date.start,
        enddate: this.date.end
      })
    }
  }
}
</script>

<style scoped>
.custom__button {
  width: 250px;
  height: 30px;
  display: flex;
  padding: 7px;
  max-width: 250px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  margin-right: 0;
  border-radius: 12px;
  margin-bottom: 0;
  justify-content: center;
  background-color: var(--dl-color-default-primarysuccess);
  font-size: 16px;
  line-height: 24px;
  color: #fff !important;
}

.column {
  display: flex;
  justify-content: center;
  width: 100%;
}

.card-title {
  text-align: center;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
  padding: 0 25px;
}
</style>